import React, { ReactNode } from 'react'

import styles from './index.module.css'

interface IMainProps {
  children: ReactNode
}

export const Main = (props: IMainProps) => {
  const { children } = props

  return <div className={styles.container}>{children}</div>
}

Main.displayName = 'Card.Main'
